export default __webpack_public_path__ + "static/media/Chestguard of the Dauntless.6edb8395.jpg";